// create a google route map for an address entry
export default function getGoogleRouteLinkForAddress(address) {
  if (address && address.address) {
    const parts = [address.address];
    ["zip", "city", "district", "country"].forEach(adr => {
      if (address[adr]) parts.push(address[adr]);
    });
    return encodeURIComponent(parts.join(" "));
  }
  return undefined;
}
